<template>
<div>
  <btn @click="importSheets" type="danger" disabled>Goutorbe</btn>
  <modal v-model="show"
         :header="false"
         :backdrop="false"
         :keyboard="false"
         :footer="false">
    <h2>Import Goutorbe</h2>
    <div class="row">
      <div class="col-xs-12">
        <p>
          <input ref="fileInput" type="file" single>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <steps :steps="iterator.steps" :stepStates="iterator.stepStates"></steps>
      </div>
    </div>
    <div v-if="completed">
      <btn @click="hide" type="default">Retour</btn>
    </div>
  </modal>
  <modal v-model="ufs.modal"
         :backdrop="false"
         :dismiss-btn="false"
         :keyboard="false"
         title="Association des Ufs">
    <div class="form-group"
         v-for="(u, k) in ufs.list"
         :key="`import-goutorbe-uf-${k}`">
      <label for="`import-goutorbe-uf-${k}-name`">Code service {{ u }}</label>
      <select v-model="ufs.result[u]"
              class="form-control">
        <option disabled value="">Uf associée</option>
        <option v-for="(v, j) in availableUfs"
                :value="v"
                :key="`import-goutorbe-uf-${k}-av-${j}`">
          {{ v.name }} ({{ v.typename }})
        </option>
      </select>
    </div>
    <collapse v-model="ufs.error.show">
      <alert type="danger">
        <strong>{{ ufs.error.title }}</strong>
        <p v-for="(e, i) in ufs.error.texts" :key="i">{{ e }}</p>
      </alert>
    </collapse>
    <div slot="footer">
      <btn @click="checkUfs" type="primary">Confirmer</btn>
    </div>
  </modal>
</div>
</template>
<script>
import StepIterator from '@/sui/tools/stepiterator'
import stepsViewer from '@/sui/components/steps'
import baseSteps from '@/components/sheets/import/impl/steps'
import impl from '@/components/sheets/import/impl/goutorbe'
import units from '@/sui/data/units'

export default {
  name: 'sheets-import-goutorbe',
  props: {
    surveillance: {
      type: Object,
      required: true
    }
  },

  data: function () {
    const steps = [
      baseSteps.load(
        'Fichier Patient', 'Impossible de charger le fichier patient'
      ),
      baseSteps.transform(
        'Ajout des patients', 'Impossible de traiter le fichier patient',
        (count) => `${count} lignes ajoutés avec succès.`,
        (data, o, start, end) => {
          if (start === 0) {
            data.sheets = {}
            data.units = []
          }
          for (let i = start; i !== end; ++i) {
            const patient = o[i]
            const num = patient.sheetNumber
            if (data.sheets[num] == null) {
              data.sheets[num] = impl.createPatient(patient)
            }
            impl.extractPatientField(data.sheets[num], patient.field, patient.value)
            if (data.units.indexOf(patient.uf) === -1) {
              data.units.push(patient.uf)
            }
          }
        }
      ),
      baseSteps.load(
        'Fichier CVC', 'Impossible de charger le fichier CVC'
      ),
      baseSteps.transform(
        'Ajout des CVCs', 'Impossible de traiter le fichier CVC',
        (count) => `${count} lignes ajoutés avec succès.`,
        (data, o, start, end) => {
          for (let i = start; i !== end; ++i) {
            const kt = o[i]
            if (data.sheets[kt.sheetNumber] == null) {
              throw new Error(
                `KT #${i} has an invalid sheet number: ${kt.sheetNumber}`
              )
            }

            const transformed = impl.createCVC(kt)
            data.sheets[kt.sheetNumber].catheters.push(transformed)
          }
        }
      ),
      baseSteps.load(
        'Fichier bactériémies', 'Impossible de charger le fichier bactériémies'
      ),
      baseSteps.transform(
        'Ajout des bactériémies', 'Impossible de traiter le fichier bactériémies',
        (count) => `${count} bactériémies ajoutées avec succès.`,
        (data, o, start, end) => {
          let current = data.current
          let bacts = data.bacts == null ? [] : data.bacts
          for (let p = start; p !== end; ++p) {
            const line = o[p]
            if (data.sheets[line.sheetNumber] == null) {
              throw new Error(
                `Bacteremia #${p} has an invalid sheet number:
${line.sheetNumber}`
              )
            }
            if (line.sheetNumber !== current) {
              if (current != null) {
                data.sheets[current].bacteremias = bacts
              }

              if (line.field !== 'bactEpisod') {
                throw new Error(
                  `Bacteremia #${p}, expected bactEpisod, got ${line.field}
(${current}, ${line.sheetNumber})`
                )
              }

              bacts = []
            }
            if ((line.sheetNumber !== current) ||
                (bacts.length > 0 && line.field === 'bactEpisod')) {
              bacts.push({ present: 1, microOrganisms: [] })
            }
            current = line.sheetNumber
            if (bacts.length === 0) {
              throw new Error(
                `Bacteremia #${p} tries to fill an empty bacteremia in sheet:
${line.sheetNumber}`
              )
            }
            const last = bacts[bacts.length - 1]
            impl.extractBactField(last, line.field, line.value)
          }
          data.current = current
          data.bacts = bacts
        }
      ),
      {
        title: 'Sélection des Ufs',
        run: function (vm, data, iteration) {
          if (iteration === 0) {
            vm.showUfsModal(data.units)
          }

          if (!vm.ufs.modal && !vm.ufs.error.show) {
            for (let i in data.sheets) {
              const sheet = data.sheets[i]
              const unit = vm.ufs.result[sheet.uf.toString()]
              sheet.unitType = unit.type
              sheet.uf = unit.name
            }
            return { end: true, success: true }
          }
          return { end: !vm.ufs.modal, success: !vm.ufs.error.show }
        },

        setError: function (e) {
          return `Erreur lors de l'association des Ufs avec les codes services : ${e}.`
        }
      },
      baseSteps.insert('reaBactADI')
    ]

    return {
      show: false,
      iterator: new StepIterator(steps),
      ufs: {
        modal: false,
        result: {},
        list: [],
        error: {
          show: false,
          texts: [],
          title: ''
        }
      }
    }
  },

  computed: {
    unitTypes: function () {
      return units['2019'].adRea
    },

    completed: function () {
      return this.iterator.completed
    },

    availableUfs: function () {
      if (this.surveillance == null) {
        return []
      }

      const result = []
      const rea = this.surveillance.modules.reaBactADI.ufs
      rea.forEach(
        (r) => {
          const typename = this.unitTypes.find((e) => e.index === r.type).code
          result.push({ type: r.type, typename: typename, name: r.name })
        }
      )
      return result
    }
  },

  watch: {
    show: function (value) {
      if (!value) {
        this.iterator.reset()
      }
    }
  },

  methods: {
    importSheets: function () {
      this.iterator.start(this)
      this.show = true
    },

    hide: function () {
      this.show = false
    },

    setError: function (title, texts) {
      this.ufs.error.show = true
      this.ufs.error.title = title
      this.ufs.error.texts = texts
    },

    checkUfs: function () {
      const ufs = []
      for (let i in this.ufs.list) {
        const s = this.ufs.list[i]
        const r = this.ufs.result[s]
        if (r == null) {
          this.setError(
            'Attention !',
            [ 'Toutes les codes services doivent être associés.' ]
          )
          return
        } else if (ufs.indexOf(r) !== -1) {
          this.setError(
            'Attention !',
            [ 'Une Uf ne peut être utilisée que pour un seul code service.' ]
          )
          return
        } else {
          ufs.push(r)
        }
      }
      this.ufs.modal = false
    },

    showUfsModal: function (units) {
      this.ufs.error.show = false
      this.ufs.list = units
      this.ufs.result = []
      this.ufs.modal = true
    }
  },

  components: {
    'steps': stepsViewer
  }
}
</script>
<style lang="less" scoped>
</style>
